import { useDispatch } from "react-redux";
import { persistor } from "../store";

// Clear actions from slices that have them
import { clearFilters as clearClientFilter } from "../store/reducers/clientFilterSlice";
import { clearTicketTaskFilters } from "../store/reducers/TicketTaskFilter";
import { clearFilters as clearUserFilter } from "../store/reducers/UserFilterSlice";
import { clear as clearDropdownList } from "../store/reducers/AssigneeTeamDropdownSlice";
import { clear as clearSharedLayout } from "../store/reducers/SharedLayoutDataSlice";

const useClearRedux = () => {
  const dispatch = useDispatch();

  const clearRedux = async () => {
    await persistor.purge();

    dispatch(clearClientFilter());
    dispatch(clearTicketTaskFilters());
    dispatch(clearUserFilter());
    dispatch(clearDropdownList());
    dispatch(clearSharedLayout());
  };

  return { clearRedux };
};

export default useClearRedux;
